import dayjs from 'dayjs';
import axios from 'axios';
import router from './router';
import store from './store';
import ImageResize from 'image-resize';
import html2canvas from 'html2canvas';
// import _ from 'lodash';

axios.defaults.headers.common.Accept = 'application/json';

const ITEM_STATE = { sell: '매각', ready: '준비', hold: '보류', done: '매물' };

const PY_M2_EX = 3.3058;
const M2_PY_EX = 0.3025;

const COM_INFO = {
	MEM_RANK: 'mem_rank',
	TEAM: 'team',
	TEAM_CATE: 'team_cate',
	EXPERT_PART: 'expert_part',
	mem_rank: '직급',
	team: '부서',
	team_cate: '팀',
	expert_part: '전문분야',
};

const BUILDING_INFO = {
	BD_CATE: 'bd_cate',
	USE_AREA: 'use_area',
	STRUCTURE: 'structure',
	GMOK: 'gmok',
	PARK_TYPE: 'park_type',
	HEAT_TYPE: 'heat_type',
	WORK_TYPE: 'work_type',
	bd_cate: '매물종류',
	use_area: '용도지역',
	structure: '건물구조',
	gmok: '지목',
	park_type: '주차방식',
	heat_type: '냉/난방',
	work_type: '작업구분',
};

const MONEY_FORMAT_TYPE = {
	LITTLE: 'LITTLE',
	MUCH: 'MUCH',
	LOAN: 'LOAN',
	RANGE: 'RANGE',
	TAX: 'TAX',
	MOBILE: 'MOBILE',
	MOBILE2: 'MOBILE2',
};

const CLIENT_LOG_TYPE = {
	mgr_level: '관리등급변경',
	chg_mgr: '관리자변경',
	chg_mobile: '휴대폰변경',
	client_type: '고객분류변경',
	etc: '기타',
};

const LOG_CHG_INFO = {
	sell_status: '진행상태',
	chk_status: '상태',
	open_flag: '공개여부',
	building_price: '건물가',
	building_price_py_price: '건물평당가격',
	land_size_p: '대지면적',
	land_size_m2: '대지면적',
	use_area_uid: '용도지역',
	substation: '주변역',
	substation_distance: '주변역거리',
	public_land_price: '공시지가',
	public_land_price_py_price: '평당공시지가',
	roadwide: '도로사항',
	total_size_p: '연면적',
	total_size_m2: '연면적',
	build_size_p: '건물면적',
	build_size_m2: '건물면적',
	floor_cnt_B: '지하층수',
	floor_cnt_F: '지상층수',
	build_date: '준공일자',
	remodel_date: '리모델링',
	bl_ratio: '건폐율',
	fa_ratio: '용적률',
	park_type_uid: '주차방식',
	park_cnt_law: '법정주차',
	park_cnt_real: '실제주차',
	heat_type_uid: '냉/난방방식',
	ev_cnt: '승강기수',
	delete: '물건삭제',
	un_del: '물건삭제',
	ins_price: '입금가',
	sell_price: '매매금액',
	building_mem_uid: '담당자',
	building_name: '물건명',
	building_addr: '물건주소',
	ex_sum_rent_deposit: '보증금',
	ex_sum_rent_money: '월임대료',
	ex_sum_mgr_fee: '관리비',
	ex_sum_mgr_fee_out: '관리비지출',
	owner_info: '소유자정보',
	toss_building_mem_uid: '위탁관리지정',
	memo: '특징',
	cont_pay_date: '계약일',
	balance_date: '잔금일',
	mid_pay_date: '중도금',
	working_status: '작업상태',
};

const INTERIOR_TYPE = {
	need: '필요',
	good: '양호',
	demo: '철거완료',
};

const RENT_FREE = {
	none: '협의',
	confer: '0개월',
};

const CLIENT_TYPE = {
	MANAGE: 'manage',
	NONE: 'none',
	PROPERTY: 'property',
	BLACK: 'black',
	CONTRACT: 'contract',
	manage: '관리',
	none: '미관리',
	property: '부동산',
	black: '블랙',
	contract: '계약',
};

const HIRE_STATUS = {
	Y: '재직',
	N: '퇴사',
};

const MEM_TYPE = {
	master: '관리자',
	admin: '직원',
};

const MONEY1 = {
	masked: false,
	prefix: '',
	suffix: '',
	thousands: ',',
	decimal: '.',
	precision: 0,
	disableNegative: false,
	disabled: false,
	min: null,
	max: null,
	allowBlank: false,
	minimumNumberOfCharacters: 0,
	shouldRound: true,
	focusOnRight: false,
};

const MONEY2 = {
	masked: false,
	prefix: '',
	suffix: '',
	thousands: ',',
	decimal: '.',
	precision: 2,
	disableNegative: false,
	disabled: false,
	min: null,
	max: null,
	allowBlank: false,
	minimumNumberOfCharacters: 0,
	shouldRound: true,
	focusOnRight: false,
};

const IMG_NAME = {
	0: '건물외관',
	1: '건물외관측면',
	2: '외부출입계단',
	3: '건물주차장',
	4: '건물 주출입구',
	5: '건물이면출입구',
	6: '건물외부사진1',
	7: '건물외부사진2',
	8: '건물외부사진3',
	9: '건물외부사진4',
};

const CID_LIST = {
	174: '신축',
	178: '24시간 개방',
	182: '야외 테라스',
	175: '단독사옥(통임대)',
	179: '높은 층고',
	186: '인테리어',
	176: '역세권',
	180: '엘리베이터 有',
	183: '자주식주차가능',
	177: '대로변',
	181: '전기차 충전소',
	184: '외부 화장실',
	187: 'PM추천',
	185: '시세보다 저렴한',
};

function c(e, t, a, r) {
	if ('number' != typeof e) return '0';
	var l = e,
		o = '',
		i = !1;
	l < 0 && ((l *= -1), (i = !0)), a && (l *= 1e4);
	var s = Math.floor(l / 1e8),
		c = Math.floor(l % 1e8),
		m = Math.floor(c / 1e4),
		p = Math.floor(c % 1e4);
	switch (t) {
		case MONEY_FORMAT_TYPE.MUCH:
			if (0 === l) break;
			var d = void 0;
			if (
				(l >= 1e8
					? ((d = l / 1e8), (o = '억'))
					: l >= 1e7
					? ((d = l / 1e7), (o = '천'))
					: l >= 1e6
					? ((d = l / 1e6), (o = '백'))
					: l >= 1e4
					? ((d = l / 1e4), (o = '만'))
					: l >= 1 && ((d = l), (o = '원')),
				'number' == typeof r)
			) {
				var u = d.toString(),
					E = u.indexOf('.');
				0 === r ? (d = parseInt(d)) : E > 0 && (d = u.slice(0, E + 1 + r));
			}
			o = d + o;
			break;
		case MONEY_FORMAT_TYPE.LITTLE:
			if (0 === l) {
				o = '0';
				break;
			}
			s > 0 && (o = s.toLocaleString() + '억'), m > 0 && (o += m.toLocaleString());
			break;
		case MONEY_FORMAT_TYPE.LOAN:
			if (0 === l) {
				o = '0';
				break;
			}
			s > 0 && (o = s.toLocaleString() + '억'),
				m > 0 && (o += m.toLocaleString() + '만'),
				p > 0 && (o += p.toLocaleString() + '원');
			break;
		case MONEY_FORMAT_TYPE.TAX:
			if (0 === l) {
				o = '-원';
				break;
			}
			s > 0 && (o = s.toLocaleString() + '억'),
				m > 0 && (o += ' ' + m.toLocaleString() + '만'),
				p > 0 && (o += ' ' + p.toLocaleString()),
				(o += '원'),
				o.trim();
			break;
		case MONEY_FORMAT_TYPE.MOBILE:
			if (0 === l) {
				o = '0';
				break;
			}
			s > 0 && (o = s.toLocaleString() + '억'), m > 0 && (o += o ? ' ' + m.toLocaleString() : m.toLocaleString());
			break;
		case MONEY_FORMAT_TYPE.MOBILE2:
			if (0 === l) {
				o = '0';
				break;
			}
			s > 0 && (o = s.toLocaleString() + '억'),
				m > 0 && (o += o ? ' ' + m.toLocaleString() + '만' : m.toLocaleString() + '만');
	}
	return i && (o = '-' + o), o;
}
// axios.defaults.headers.common['X-NCP-APIGW-API-KEY-ID'] = 'egpy3fy0c0';
// axios.defaults.headers.common['X-NCP-APIGW-API-KEY'] = 'hUHbBHnw5smY4JLYbecqBNkEMsjaf55rkGSp1iWv';

function base64toFile(base_data, filename) {
	var arr = base_data.split(','),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new File([u8arr], filename, { type: mime });
}

// class initOptions {
// 	_canvasOptions = {
// 		fileName: '',
// 		allowTaint: true,
// 		useCORS: true,
// 		logging: true,
// 		height: 0,
// 		width: 0,
// 		scale: 1,
// 		dpi: 600,
// 		scrollX: 0,
// 		scrollY: 0,
// 		fileExtension: 'pdf',
// 	};

// 	constructor(canvasOptions) {
// 		this.canvasOptions = _.merge(this._canvasOptions, canvasOptions);
// 	}

// 	get canvasOptions() {
// 		return this._canvasOptions;
// 	}

// 	set canvasOptions(value) {
// 		this._canvasOptions = _.merge(this._canvasOptions, value);
// 	}
// }

const methods = {
	exportPrint: async elementList => {
		const canvasOptions = {
			fileName: '',
			allowTaint: false,
			useCORS: true,
			logging: false,
			scale: 1,
			dpi: 600,
			scrollX: 0,
			scrollY: 0,
			fileExtension: 'pdf',
		};

		const my_window = window.open('', '', `width=${canvasOptions.width},height=${canvasOptions.height}`);
		const style = document.createElement('style');
		// html, body { -webkit-print-color-adjust:exact; width: 210mm; height: 297mm; }
		style.textContent = `
			body { margin: 0px;}
			@media print {
				html, body { -webkit-print-color-adjust:exact; width: 297mm; height: 210mm;}
				table { page-break-inside:auto; }
				tr    { page-break-inside:avoid; page-break-after:auto; }
				thead { display:table-header-group; }
				tfoot { display:table-footer-group; }
			}
			@page { size: A4 landscape; margin:0px; }   
			`;
		// @page { size: A4 portrait; margin:0; }   //A4 세로 출력
		// @page { size: A4 landscape; margin:0; }   //A4 가로 출력

		const newDiv = document.createElement('div');

		for (let i = 0; i < elementList.length; i++) {
			let elementDOM = document.getElementById(elementList[i]);

			const canvas = await html2canvas(elementDOM, canvasOptions);

			newDiv.appendChild(canvas);
		}

		my_window.document.head.appendChild(style);
		my_window.document.body.appendChild(newDiv);

		my_window.focus();
		my_window.print();
		my_window.close();
	},

	dateKorFormat: day => {
		if (typeof day != 'string') {
			return null;
		} else if (day == '0000-00-00' || day == null || !day.length) {
			return null;
		} else {
			return dayjs(day).format('YYYY년 MM월 DD일');
		}
	},
	dateKorFormat2: day => {
		if (typeof day != 'string') {
			return null;
		} else if (day == '0000-00-00' || day == null || !day.length) {
			return null;
		} else {
			return dayjs(day).format('YYYY년 MM월 DD일');
		}
	},

	dateKorFormat3: day => {
		if (typeof day != 'string') {
			return null;
		} else if (day == '0000-00-00' || day == null || !day.length) {
			return null;
		} else {
			return dayjs(day).format('YYYY.MM.DD');
		}
	},

	dateKorFormat4: day => {
		if (typeof day != 'string') {
			return null;
		} else if (day == '0000-00-00' || day == null || !day.length) {
			return null;
		} else {
			return dayjs(day).format('YYYY-MM-DD');
		}
	},

	dateToFormat: (day, format) => {
		// return dayjs(day).format('YYYY-MM-DD');
		return dayjs(day).format(format);
	},

	dateFormat: day => {
		if (typeof day != 'string') {
			return null;
		} else if (day == '0000-00-00' || day == null || !day.length) {
			return null;
		} else {
			return dayjs(day).format('YYYY-MM-DD');
		}
	},

	dateSub: day => {
		const masTime = new Date(day);
		const todayTime = new Date();
		todayTime.setHours(0, 0, 0, 0);
		const diff = masTime - todayTime;
		const diffDay = Math.floor(diff / (1000 * 60 * 60 * 24));

		if (diffDay < 0) {
			return '';
		} else if (diffDay == 0) {
			return '오늘까지';
		} else {
			return 'D-' + diffDay;
		}
	},

	getFloorString(f_B, f_F) {
		let floor_string = '';
		if (f_B > 0) {
			floor_string = '지하' + f_B + '층';
		}
		if (f_F > 0) {
			if (floor_string != '') {
				floor_string += '/';
			}
			floor_string += '지상' + f_F + '층';
		}
		return floor_string;
	},

	getFloorString2(f_B, f_F) {
		let floor_string = '';
		if (f_B > 0) {
			floor_string = '지하' + f_B + '층';
		}
		if (f_F > 0) {
			if (floor_string != '') {
				floor_string += '~';
			}
			floor_string += '지상' + f_F + '층';
		}
		return floor_string;
	},

	getFloorString3(f_B, f_F) {
		let floor_string = '';
		if (f_B > 0) {
			floor_string = 'B' + f_B;
		}
		if (f_F > 0) {
			if (floor_string != '') {
				floor_string += '-';
			}
			floor_string += f_F;
		}
		return floor_string;
	},

	setPyToM2(val) {
		if (!val) {
			return;
		}
		const re = val * PY_M2_EX;

		return Number(re.toFixed(2));
	},
	setM2ToPy(val) {
		if (!val) {
			return;
		}
		const re = val * M2_PY_EX;

		return Number(re.toFixed(2));
	},

	numberToKorean(number) {
		return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	},
	formatMoney(e, t, a) {
		return c(e, t, !0, a);
	},
	formatMoneyBasedOnWon(e, t, a) {
		var r = e;
		return 'string' == typeof e && (r = parseInt(e, 10)), c(r, t, !1, a);
	},

	vaileEmail(email) {
		const pattern = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
		return email.match(pattern) != null;
	},

	groupBy(data, key) {
		return data.reduce(function (carry, el) {
			var group = el[key];

			if (carry[group] === undefined) {
				carry[group] = [];
			}

			carry[group].push(el);
			return carry;
		}, {});
	},
	isEmpty(value) {
		if (
			value == '' ||
			value == null ||
			value == undefined ||
			(value != null && typeof value == 'object' && !Object.keys(value).length)
		) {
			return false;
		} else {
			return true;
		}
	},
	pageDataSetting(total, limit, block, page) {
		this.isAllCheck = false;
		const totalPage = Math.ceil(total / limit);
		let currentPage = page;
		const first = currentPage > 1 ? parseInt(currentPage, 10) - parseInt(1, 10) : null;
		const end = totalPage !== currentPage ? parseInt(currentPage, 10) + parseInt(1, 10) : null;

		let startIndex = (Math.ceil(currentPage / block) - 1) * block + 1;
		let endIndex = startIndex + block > totalPage ? totalPage : startIndex + block - 1;
		let list = [];
		for (let index = startIndex; index <= endIndex; index++) {
			list.push(index);
		}
		return { first, end, list, currentPage, totalPage };
	},
	objCompare(pt1, pt2) {
		if (pt1.x === pt2.x && pt1.y === pt2.y) {
			return true;
		}
		return false;
	},

	apiGET: async _path => {
		const path = process.env.VUE_APP_HOST_BACK + _path;

		let msg = '잠시후 다시 시도 해주세요.';
		try {
			const storeToken = store.getters.getToken;

			if (storeToken) {
				axios.defaults.headers.common.authorization = storeToken.accessToken;
				axios.defaults.headers.common.refresh = storeToken.refreshToken;
			}

			const re = await axios.get(path);

			if (re.data.status == 402) {
				const ref = await axios.get(process.env.VUE_APP_HOST_BACK + '/users/refresh');
				axios.defaults.headers.common.authorization = ref.data.data.accessToken;
				axios.defaults.headers.common.refresh = ref.data.data.refreshToken;

				store.dispatch('callSetToken', {
					accessToken: ref.data.data.accessToken,
					refreshToken: ref.data.data.refreshToken,
				});

				const re_ = await axios.get(path);
				return re_.data;
			} else {
				return re.data;
			}
		} catch (e) {
			if (e.response?.status == 400) {
				if (e.response?.data?.errors?.length) {
					alert(e.response?.data.errors);
				}
				return false;
			} else if (e.response?.status == 401) {
				axios.defaults.headers.common.authorization = '';
				axios.defaults.headers.common.refresh = '';

				router.push({
					name: 'Login',
				});
				return;
			} else {
				if (e.response.data.message) {
					alert(msg);
				}
			}
		}
	},

	apiPOST: async (_path, param) => {
		const path = process.env.VUE_APP_HOST_BACK + _path;

		let msg = '잠시후 다시 시도 해주세요.';
		try {
			const storeToken = store.getters.getToken;

			if (storeToken) {
				axios.defaults.headers.common.authorization = storeToken.accessToken;
				axios.defaults.headers.common.refresh = storeToken.refreshToken;
			}

			const re = await axios.post(path, param);
			if (re.data.status == 402) {
				const ref = await axios.get(process.env.VUE_APP_HOST_BACK + '/users/refresh');
				axios.defaults.headers.common.authorization = ref.data.data.accessToken;
				axios.defaults.headers.common.refresh = ref.data.data.refreshToken;

				store.dispatch('callSetToken', {
					accessToken: ref.data.data.accessToken,
					refreshToken: ref.data.data.refreshToken,
				});

				const re_ = await axios.post(path, param);
				return re_.data;
			} else {
				return re.data;
			}
		} catch (e) {
			if (e.response?.status == 400) {
				if (e.response?.data?.errors?.length) {
					alert(e.response?.data.errors);
				}
				return false;
			} else if (e.response?.status == 401) {
				axios.defaults.headers.common.authorization = '';
				axios.defaults.headers.common.refresh = '';

				router.push({
					name: 'Login',
				});
				return;
			} else {
				if (e.response.data.message) {
					alert(msg);
				}
			}

			return;
		}
	},

	apiLOGIN: async (_path, param) => {
		const path = process.env.VUE_APP_HOST_BACK + _path;

		try {
			const re = await axios.post(path, param);

			axios.defaults.headers.common.authorization = 'Bearer ' + re.data.token.accessToken;
			axios.defaults.headers.common.refresh = 'Bearer ' + re.data.refreshToken;

			store.dispatch('callSetToken', {
				accessToken: 'Bearer ' + re.data.token.accessToken,
				refreshToken: 'Bearer ' + re.data.token.refreshToken,
			});

			router.push({
				name: 'Proposal',
			});

			return re.data;
		} catch (e) {
			if (e.response.data.message) {
				alert(e.response.data.message);
			}
			return;
		}
	},

	apiLOGOUT: async (_path, param) => {
		const path = process.env.VUE_APP_HOST_BACK + _path;
		try {
			const storeToken = store.getters.getToken;

			if (storeToken) {
				axios.defaults.headers.common.authorization = storeToken.accessToken;
				axios.defaults.headers.common.refresh = storeToken.refreshToken;
			}

			store.dispatch('callSetToken', { accessToken: '', refreshToken: '' });

			router.push({
				name: 'Service',
			});

			const re = await axios.post(path, param);
			return re.data;
		} catch (e) {
			if (e.response.data.message) {
				alert(e.response.data.message);
			}
			return;
		}
	},

	apiIMG: async (_path, param, imgList) => {
		const path = process.env.VUE_APP_HOST_BACK + _path;
		let msg = '잠시후 다시 시도 해주세요.';
		try {
			const header = { 'Content-Type': 'multipart/form-data' };
			let form = new FormData();
			// let img = files;

			form.append('bid', param);

			for (let i = 0; i < imgList.length; i++) {
				form.append('images', imgList[i].file);

				if (!imgList[i].src && imgList[i].fileSrc) {
					//신규
					form.append('info_' + i, 0);
				} else if (imgList[i].src && imgList[i].fileSrc) {
					//수정
					form.append('info_' + i, 1);
				} else {
					//idle
					form.append('info_' + i, -1);
				}
			}

			const storeToken = store.getters.getToken;

			if (storeToken) {
				axios.defaults.headers.common.authorization = storeToken.accessToken;
				axios.defaults.headers.common.refresh = storeToken.refreshToken;
			}

			const re = await axios.post(path, form, header);
			if (re.data.status == 402) {
				const ref = await axios.get(process.env.VUE_APP_HOST_BACK + '/users/refresh');
				axios.defaults.headers.common.authorization = ref.data.data.accessToken;
				axios.defaults.headers.common.refresh = ref.data.data.refreshToken;

				store.dispatch('callSetToken', {
					accessToken: ref.data.data.accessToken,
					refreshToken: ref.data.data.refreshToken,
				});

				const re_ = await axios.post(path, form, header);
				return re_.data;
			} else {
				return re.data;
			}
		} catch (e) {
			if (e.response?.status == 400) {
				if (e.response?.data?.errors?.length) {
					alert(e.response?.data.errors[0].msg);
				}
				return false;
			} else if (e.response?.status == 401) {
				axios.defaults.headers.common.authorization = '';
				axios.defaults.headers.common.refresh = '';

				router.push({
					name: 'Login',
				});
				return;
			} else {
				if (e.response.data.message) {
					alert(msg);
				}
			}
			return;
		}
	},

	imgResize: async file => {
		var imageResize = new ImageResize({
			format: 'png',
			width: 200,
			height: 200,
			quality: 0.6,
		});

		let _base64 = await imageResize.play(file);
		let _file = base64toFile(_base64, file.name);

		return { file: _file, base64: _base64 };
	},
};

export default {
	install(Vue) {
		Vue.config.globalProperties.$RENT_FREE = RENT_FREE;
		Vue.config.globalProperties.$INTERIOR_TYPE = INTERIOR_TYPE;
		Vue.config.globalProperties.$CID_LIST = CID_LIST;
		Vue.config.globalProperties.$IMG_NAME = IMG_NAME;
		Vue.config.globalProperties.$MONEY1 = MONEY1;
		Vue.config.globalProperties.$MONEY2 = MONEY2;
		Vue.config.globalProperties.$M2_PY_EX = M2_PY_EX;
		Vue.config.globalProperties.$PY_M2_EX = PY_M2_EX;
		Vue.config.globalProperties.$ITEM_STATE = ITEM_STATE;
		Vue.config.globalProperties.$CLIENT_LOG_TYPE = CLIENT_LOG_TYPE;
		Vue.config.globalProperties.$CLIENT_TYPE = CLIENT_TYPE;
		Vue.config.globalProperties.$COM_INFO = COM_INFO;
		Vue.config.globalProperties.$BUILDING_INFO = BUILDING_INFO;
		Vue.config.globalProperties.$MEM_TYPE = MEM_TYPE;
		Vue.config.globalProperties.$HIRE_STATUS = HIRE_STATUS;
		Vue.config.globalProperties.$LOG_CHG_INFO = LOG_CHG_INFO;
		Vue.config.globalProperties.$MONEY_FORMAT_TYPE = MONEY_FORMAT_TYPE;
		Vue.config.globalProperties.$dateFormat = methods.dateFormat;
		Vue.config.globalProperties.$dateSub = methods.dateSub;
		Vue.config.globalProperties.$getFloorString = methods.getFloorString;
		Vue.config.globalProperties.$getFloorString2 = methods.getFloorString2;
		Vue.config.globalProperties.$getFloorString3 = methods.getFloorString3;
		Vue.config.globalProperties.$numberToKorean = methods.numberToKorean;
		Vue.config.globalProperties.$formatMoney = methods.formatMoney;
		Vue.config.globalProperties.$formatMoneyBasedOnWon = methods.formatMoneyBasedOnWon;
		Vue.config.globalProperties.$groupBy = methods.groupBy;
		Vue.config.globalProperties.$isEmpty = methods.isEmpty;
		Vue.config.globalProperties.$pageDataSetting = methods.pageDataSetting;
		Vue.config.globalProperties.$objCompare = methods.objCompare;
		Vue.config.globalProperties.$apiGET = methods.apiGET;
		Vue.config.globalProperties.$apiPOST = methods.apiPOST;
		Vue.config.globalProperties.$apiLOGIN = methods.apiLOGIN;
		Vue.config.globalProperties.$apiLOGOUT = methods.apiLOGOUT;
		Vue.config.globalProperties.$apiIMG = methods.apiIMG;
		Vue.config.globalProperties.$imgResize = methods.imgResize;
		Vue.config.globalProperties.$exportPrint = methods.exportPrint;
		Vue.config.globalProperties.$dateKorFormat = methods.dateKorFormat;
		Vue.config.globalProperties.$dateKorFormat2 = methods.dateKorFormat2;
		Vue.config.globalProperties.$dateKorFormat3 = methods.dateKorFormat3;
		Vue.config.globalProperties.$dateKorFormat4 = methods.dateKorFormat4;
		Vue.config.globalProperties.$dateToFormat = methods.dateToFormat;
		Vue.config.globalProperties.$setM2ToPy = methods.setM2ToPy;
		Vue.config.globalProperties.$setPyToM2 = methods.setPyToM2;
		Vue.config.globalProperties.$vaileEmail = methods.vaileEmail;
	},
};
